import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'panel-usage',
  templateUrl: './panel-usage.component.html',
  styleUrls: ['./panel-usage.component.sass']
})
export class PanelUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
